module.exports = __webpack_public_path__ + "static/img/piao-wd.be5a1b0.jpg";